var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.0667 16.7C62.4 14.7333 60.5333 13.3333 58.3333 13.3333H21.6667C19.4667 13.3333 17.6333 14.7333 16.9333 16.7L10 36.6667V63.3333C10 65.1667 11.5 66.6667 13.3333 66.6667H16.6667C18.5 66.6667 20 65.1667 20 63.3333V60H60V63.3333C60 65.1667 61.5 66.6667 63.3333 66.6667H66.6667C68.5 66.6667 70 65.1667 70 63.3333V36.6667L63.0667 16.7ZM22.8333 20H57.1333L60.7333 30.3667H19.2333L22.8333 20ZM63.3333 53.3333H16.6667V36.6667H63.3333V53.3333Z",
    fill: "#00008F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C27.7614 50 30 47.7614 30 45C30 42.2386 27.7614 40 25 40C22.2386 40 20 42.2386 20 45C20 47.7614 22.2386 50 25 50Z",
    fill: "#00008F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55 50C57.7614 50 60 47.7614 60 45C60 42.2386 57.7614 40 55 40C52.2386 40 50 42.2386 50 45C50 47.7614 52.2386 50 55 50Z",
    fill: "#00008F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.dd83921833ad6c388085bd1893ca9998.svg";
export { ForwardRef as ReactComponent };